import React, { useState, useEffect } from 'react';
import MUIDataTable from 'mui-datatables';
import { useSelector } from 'react-redux';
import { useSnackbar } from 'notistack';
import { getClientSelector } from 'src/store/sharedStore/selectors';
import { useQuery, useMutation, useLazyQuery } from '@apollo/react-hooks';
import moment from 'moment';
import { IconButton, Tooltip, Typography, TableCell } from '@material-ui/core';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import PageviewOutlinedIcon from '@material-ui/icons/PageviewOutlined';
import CryptoJS from 'crypto-js';
import useStyles from './styles';
import { textLabels } from '../../../translations/components/MUIDataTable';
import {
  LIST_S3FILES_BY_CLIENT,
  LIST_S3FILES_BY_EMPLOYEE,
  LIST_TYPES_CHOICES,
  LIST_TYPES_CHOICES_EMPLOYEE,
  FILE_DOWNLOAD,
} from '../Files/queries';
import {
  LIST_S3FILES,
  LIST_CLASSIFICATION_CHOICES,
} from '../EmployeeFiles/queries';
import {
  generateColumn,
  edgeToList,
  errorMessage,
  successMessage,
  getDBIdFromGraphqlId,
} from '../../../utils/commonFunctions';
import LoadingIndicator from '../../LoadingIndicator';
import PDFViewerModal from '../../PDFViewerModal';
import { saveAs } from 'file-saver';
import {
  getInvestorDocuments,
  getUserIdFromLocalStorage,
} from './service/getInvestorDocuments';
import { getInvestorDocumentsPreview } from './service/getPreviewFile';
import { GET_CURRENT_USER } from '@queries/Client';
const base64url = source => {
  var encodedSource = CryptoJS.enc.Base64.stringify(source);
  encodedSource = encodedSource.replace(/=+$/, '');
  encodedSource = encodedSource.replace(/\+/g, '-');
  encodedSource = encodedSource.replace(/\//g, '_');

  return encodedSource;
};
function Documents(props) {
  const classes = useStyles();
  const { enqueueSnackbar } = useSnackbar();
  const client = useSelector(getClientSelector());
  const [loading, setLoading] = useState(false);
  const { loadings, data: clients } = useQuery(GET_CURRENT_USER, {
    fetchPolicy: 'no-cache',
  });
  const token = () => {
    let header = {
      alg: 'HS256',
      typ: 'JWT',
    };

    let stringifiedHeader = CryptoJS.enc.Utf8.parse(JSON.stringify(header));
    let encodedHeader = base64url(stringifiedHeader);
    let id = getUserIdFromLocalStorage();
    let data = {
      userId: id,
      user: clients?.currentUser?.email,
      firstName: client?.user?.firstName,
      lastName: client?.user?.lastName,
      email: clients?.currentUser?.email,
    };
    let stringifiedData = CryptoJS.enc.Utf8.parse(JSON.stringify(data));
    let encodedData = base64url(stringifiedData);
    let secret = 'core2';
    let unsigned_token = encodedHeader + '.' + encodedData;
    let signature = CryptoJS.HmacSHA256(unsigned_token, secret);
    signature = base64url(signature);
    let signedToken = unsigned_token + '.' + signature;

    return signedToken;
  };
  const UserToken = token();
  const { error: errorClient, data: dataClient } = useQuery(
    LIST_S3FILES_BY_CLIENT,
    {
      variables: { clientId: client?.id },
    },
  );
  const { error: errorEmployee, data: dataEmployee } = useQuery(
    LIST_S3FILES_BY_EMPLOYEE,
    {
      variables: { clientId: client?.id },
    },
  );
  const { error: errorGeneric, data: dataGeneric } = useQuery(LIST_S3FILES);
  const [classificationList, setClassificationList] = useState([]);
  const [filesList, setFilesList] = useState([]);
  const [typeList, setTypeList] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [isDownload, setIsDownload] = useState(false);
  const [isEmployee, setIsEmployee] = useState(client.isEmployee);
  const [url, setUrl] = useState('');
  const [investorDocuments, setInvestorDocuments] = useState([]);
  const [loadingInvestorDocs, setLoadingInvestorDocs] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const { data: ClassificationData } = useQuery(LIST_CLASSIFICATION_CHOICES);
  const {
    loading: TypesLoading,
    error: TypesError,
    data: TypesData,
  } = useQuery(LIST_TYPES_CHOICES);
  const {
    loading: TypesLoadingEmployee,
    error: TypesErrorEmployee,
    data: TypesDataEmployee,
  } = useQuery(LIST_TYPES_CHOICES_EMPLOYEE);

  const [downloadFile, { loadingFile, dataFile }] = useMutation(FILE_DOWNLOAD, {
    onError(error) {
      errorMessage(error, enqueueSnackbar);
    },
    onCompleted(data) {
      if (!!data && !isDownload) {
        setUrl(data?.fileDownload?.url);
        setShowModal(true);
      }
      if (!!data && isDownload) {
        setShowModal(false);
        saveAs(data?.fileDownload?.url, data?.fileDownload?.fileName);
        successMessage('Archivo descargado.', enqueueSnackbar);
      }
    },
  });

  const loadInvestorDocuments = React.useCallback(
    async (customPage = page, customRowsPerPage = rowsPerPage) => {
      if (!client?.id || isEmployee) return;
      try {
        setLoadingInvestorDocs(true);
        const documents = await getInvestorDocuments(
          client.id,
          customRowsPerPage,
          customPage + 1,
          UserToken,
        );
        setInvestorDocuments(documents);
      } catch (error) {
        if (!error.toString().includes('SyntaxError')) {
          errorMessage(
            'Error al cargar documentos del inversionista',
            enqueueSnackbar,
          );
        }
        setInvestorDocuments([]);
      } finally {
        setLoadingInvestorDocs(false);
      }
    },
    [client?.id, isEmployee, enqueueSnackbar, page, rowsPerPage],
  );

  useEffect(() => {
    if (isEmployee === false) {
      loadInvestorDocuments();
    }
  }, [loadInvestorDocuments, client?.id, isEmployee, page, rowsPerPage]);

  useEffect(() => {
    if (!isEmployee) {
      const data = investorDocuments.data || investorDocuments;
      setFilesList(data || []);
      if (!!TypesData) setTypeList(TypesData.typesChoices);
    } else if (!!dataEmployee && isEmployee) {
      let dataTmp = [];
      dataTmp = edgeToList(dataEmployee, 'listS3FilesByEmployee').filter(
        f => !f?.isGeneric,
      );
      setFilesList(dataTmp);
      if (!!TypesDataEmployee)
        setTypeList(TypesDataEmployee.typesChoicesEmployee);
    } else {
      setFilesList([]);
      setTypeList([]);
    }
    if (!!ClassificationData)
      setClassificationList(ClassificationData.classificationChoices);
  }, [
    investorDocuments,
    dataEmployee,
    TypesDataEmployee,
    TypesData,
    ClassificationData,
    isEmployee,
  ]);

  const handleInvestorFile = async (fileUrl, fileName, isDownload, uuid) => {
    if (isDownload) {
      const url = await getInvestorDocumentsPreview(uuid, UserToken);
      window.open(url, '_blank');
      successMessage('Archivo abierto en nueva pestaña.', enqueueSnackbar);
    } else {
      const url = await getInvestorDocumentsPreview(uuid, UserToken);
      setUrl(url);
      setShowModal(true);
    }
  };

  const getUrl = (id, fileName, isDownload) => {
    downloadFile({
      variables: { id, fileName, isDownload },
    });
  };

  const isInvestorData =
    filesList.length > 0 && filesList[0]?.uuid && filesList[0]?.fileUrl;
  let columns = [];
  if (filesList && filesList.length > 0 && !isEmployee) {
    if (isInvestorData) {
      columns = [
        generateColumn('Producto', 'productName', {
          customBodyRender: value => {
            return value || '-';
          },
        }),
        generateColumn('Clase', 'class', {
          customBodyRender: value => {
            return value || '-';
          },
        }),
        generateColumn('Extra', 'extra', {
          customBodyRender: value => {
            return value || '-';
          },
        }),
        generateColumn('Tipo de Documento', 'fileTypeName', {
          customBodyRender: value => {
            return value || '-';
          },
        }),
        generateColumn('Fecha', 'munimentDate', {
          customBodyRender: value => {
            if (value) {
              return moment(value).format('DD/MM/YYYY');
            }
            return '-';
          },
        }),
        {
          name: 'uuid',
          label: 'Opciones',
          options: {
            sort: false,
            customBodyRender: (value, tableMeta) => {
              const uuid = value;
              const fileUrl = tableMeta.rowData[6];
              const fileName = tableMeta.rowData[3];
              return (
                <>
                  <Tooltip title="Visualizar" placement="top" arrow>
                    <IconButton
                      variant="contained"
                      color="secondary"
                      size="small"
                      onClick={async $ev => {
                        $ev.stopPropagation();
                        await handleInvestorFile(
                          fileUrl,
                          fileName,
                          false,
                          uuid,
                        );
                      }}
                      className={classes.optionButtons}
                    >
                      <PageviewOutlinedIcon className={classes.optionIcon} />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Descargar" placement="top" arrow>
                    <IconButton
                      variant="contained"
                      color="secondary"
                      size="small"
                      onClick={async $ev => {
                        $ev.stopPropagation();
                        await handleInvestorFile(fileUrl, fileName, true, uuid);
                      }}
                      className={classes.optionButtons}
                    >
                      <CloudDownloadIcon className={classes.optionIcon} />
                    </IconButton>
                  </Tooltip>
                </>
              );
            },
            customHeadRender: columnMeta => {
              return (
                <TableCell key={7} style={{ borderBottom: 'none' }}>
                  <Typography
                    variant="subtitle1"
                    align="left"
                    className={classes.tableTitle}
                  >
                    {columnMeta.label}
                  </Typography>
                </TableCell>
              );
            },
          },
        },

        {
          name: 'fileUrl',
          options: {
            display: false,
          },
        },
      ];
    } else {
      columns = [
        generateColumn('Fondo', 'fund__business_name', {
          customBodyRender: value => {
            if (value) return value;
            else return '-';
          },
        }),
        generateColumn('Bono', 'bond__name', {
          customBodyRender: value => {
            if (value) return value;
            else return '-';
          },
        }),
        generateColumn('Tipo', 'file_type', {
          customBodyRender: value => {
            let name;
            if (value.length < 6) {
              typeList.map(item => {
                if (item?.value == value) {
                  name = item.name;
                }
              });
              return name;
            } else return value;
          },
        }),
        generateColumn('Documento', 'file_name', {
          customBodyRender: value => {
            return value;
          },
        }),
        {
          name: 'id',
          label: 'Opciones',
          options: {
            sort: false,
            customBodyRender: (value, tableMeta) => {
              const id = value;
              const fileName = tableMeta.rowData[3];
              return (
                <>
                  <Tooltip title="Visualizar" placement="top" arrow>
                    <IconButton
                      variant="contained"
                      color="secondary"
                      size="small"
                      onClick={$ev => {
                        $ev.stopPropagation();
                        setIsDownload(false);
                        if (id) getUrl(id, fileName, false);
                        else getUrl(0, fileName, false);
                      }}
                      className={classes.optionButtons}
                    >
                      <PageviewOutlinedIcon className={classes.optionIcon} />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Descargar" placement="top" arrow>
                    <IconButton
                      variant="contained"
                      color="secondary"
                      size="small"
                      onClick={$ev => {
                        $ev.stopPropagation();
                        setIsDownload(true);
                        if (id) getUrl(id, fileName, true);
                        else getUrl(0, fileName, true);
                      }}
                      className={classes.optionButtons}
                    >
                      <CloudDownloadIcon className={classes.optionIcon} />
                    </IconButton>
                  </Tooltip>
                </>
              );
            },
            customHeadRender: columnMeta => {
              return (
                <TableCell key={7} style={{ borderBottom: 'none' }}>
                  <Typography
                    variant="subtitle1"
                    align="left"
                    className={classes.tableTitle}
                  >
                    {columnMeta.label}
                  </Typography>
                </TableCell>
              );
            },
          },
        },
      ];
    }
  }

  if (filesList && filesList.length > 0 && isEmployee) {
    columns = [
      generateColumn('Clasificación', 'classification', {
        customBodyRender: value => {
          return classificationList?.find(item => item.value == value)?.name;
        },
      }),
      generateColumn('Tipo', 'fileType', {
        customBodyRender: value => {
          let name;
          typeList.map(item => {
            if (item?.value == value) {
              name = item.name;
            }
          });
          return name;
        },
      }),
      generateColumn('Documento', 'fileName', {
        customBodyRender: value => {
          return value;
        },
      }),
      {
        name: 'id',
        label: 'Opciones',
        options: {
          sort: false,
          customBodyRender: (value, tableMeta) => {
            const id = value;
            const fileName = tableMeta.rowData[2];
            return (
              <>
                <Tooltip title="Visualizar" placement="top" arrow>
                  <IconButton
                    variant="contained"
                    color="secondary"
                    size="small"
                    onClick={$ev => {
                      $ev.stopPropagation();
                      setIsDownload(false);
                      if (id) getUrl(id, fileName, false);
                      else getUrl(0, fileName, false);
                    }}
                    className={classes.optionButtons}
                  >
                    <PageviewOutlinedIcon className={classes.optionIcon} />
                  </IconButton>
                </Tooltip>
                <Tooltip title="Descargar" placement="top" arrow>
                  <IconButton
                    variant="contained"
                    color="secondary"
                    size="small"
                    onClick={$ev => {
                      $ev.stopPropagation();
                      setIsDownload(true);
                      if (id) getUrl(id, fileName, true);
                      else getUrl(0, fileName, true);
                    }}
                    className={classes.optionButtons}
                  >
                    <CloudDownloadIcon className={classes.optionIcon} />
                  </IconButton>
                </Tooltip>
              </>
            );
          },
          customHeadRender: columnMeta => {
            return (
              <TableCell key={7} style={{ borderBottom: 'none' }}>
                <Typography
                  variant="subtitle1"
                  align="left"
                  className={classes.tableTitle}
                >
                  {columnMeta.label}
                </Typography>
              </TableCell>
            );
          },
        },
      },
    ];
  }

  const options = {
    filterType: 'dropdown',
    responsive: 'standard',
    selectableRows: 'none',
    print: false,
    filter: false,
    download: false,
    textLabels,
    rowsPerPage,
    page,
    onChangeRowsPerPage: newSize => {
      setRowsPerPage(newSize);
      setPage(0);
    },
    onChangePage: newPage => {
      setPage(newPage);
    },
  };

  return (
    <div style={{ marginTop: '1.5em' }}>
      {loading || loadingInvestorDocs ? (
        <LoadingIndicator />
      ) : (
        <>
          <MUIDataTable
            title="Repositorio Personal"
            data={filesList}
            columns={columns}
            options={options}
          />
          <PDFViewerModal
            showModal={showModal}
            onClosePress={() => setShowModal(false)}
            fileURL={url}
            loading={loadingFile}
          />
        </>
      )}
    </div>
  );
}
export default Documents;
